module.exports = __webpack_public_path__ + "img/6_no.1706a9ad.svg";